export default __webpack_public_path__ + "static/media/Tela_acesso_OSC.eb9d1b10.png";